import Request, { SimpleResponse } from './Request';

export interface IYear {
    id: number;
    name: number;
    active: boolean;
}

class Year {
    static GetAll = (): IYear[] => { return Request.DoGet('year/all') as unknown as IYear[]; };
    static Get = (id: number): IYear => { return Request.DoGet('year/' + id) as unknown as IYear; };
    static Update = (id: number, data: IYear): SimpleResponse => { return Request.DoPut('year/' + id, data) as unknown as SimpleResponse; };
    static Create = (data: IYear): SimpleResponse => { return Request.DoPost('year', data) as unknown as SimpleResponse; };
    static Delete = (id: number): SimpleResponse => { return Request.DoDelete('year/' + id) as unknown as SimpleResponse; };
}

export default Year;